var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwapVerticalIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 15",
  fill: "currentColor",
  height: "1em",
  width: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.412 1.059v12.353h1.764V1.059z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.285 2.65L7.32 5.96l1.301-1.192L4.303.056-.025 4.653l1.285 1.21zM14.588 13.412V1.059h-1.764v12.353z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.715 11.821l-3.035-3.31-1.301 1.192 4.318 4.711 4.328-4.597-1.285-1.21z"
}))));
export default SvgSwapVerticalIconcom;